/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfAutomationPostsPreferencesOutput } from "../models/AjaxResponseOfAutomationPostsPreferencesOutput";
import type { AjaxResponseOfAutomationPostsTemplatesOutput } from "../models/AjaxResponseOfAutomationPostsTemplatesOutput";
import type { AjaxResponseOfListOfScheduledSocialMediaJobDto } from "../models/AjaxResponseOfListOfScheduledSocialMediaJobDto";
import type { AjaxResponseOfListOfSocialMediaAutomationDto } from "../models/AjaxResponseOfListOfSocialMediaAutomationDto";
import type { AjaxResponseOfSocialMediaAutomation } from "../models/AjaxResponseOfSocialMediaAutomation";
import type { AjaxResponseOfSocialMediaAutomationDto } from "../models/AjaxResponseOfSocialMediaAutomationDto";
import type { AutomationRuleDto } from "../models/AutomationRuleDto";
import type { CreateOrUpdateSocialMediaAutomation } from "../models/CreateOrUpdateSocialMediaAutomation";
import type { DeleteAutomationPostsTemplateInput } from "../models/DeleteAutomationPostsTemplateInput";
import type { UpdateAutomationPostsPreferencesInput } from "../models/UpdateAutomationPostsPreferencesInput";
import type { UpdateAutomationPostsTemplatesInput } from "../models/UpdateAutomationPostsTemplatesInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class SocialMediaAutomationAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfSocialMediaAutomationDto Success
   * @throws ApiError
   */
  public getAllAutomations(): CancelablePromise<AjaxResponseOfListOfSocialMediaAutomationDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/social-media-automation",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfSocialMediaAutomation Success
   * @throws ApiError
   */
  public createAutomation({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateSocialMediaAutomation;
  }): CancelablePromise<AjaxResponseOfSocialMediaAutomation> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/social-media-automation",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateAutomation({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateSocialMediaAutomation;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/social-media-automation",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfAutomationPostsPreferencesOutput Success
   * @throws ApiError
   */
  public getPreferences(): CancelablePromise<AjaxResponseOfAutomationPostsPreferencesOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/social-media-automation/preferences",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public updatePreferences({
    requestBody,
  }: {
    requestBody?: UpdateAutomationPostsPreferencesInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/social-media-automation/preferences",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteRuleAutomation({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/social-media-automation/rule/{id}",
      path: {
        id: id,
      },
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public addOrUpdateAutomationRules({
    requestBody,
    removedRuleIds,
  }: {
    requestBody?: Array<AutomationRuleDto>;
    removedRuleIds?: Array<number>;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/front-end/v1/social-media-automation/rules",
      query: { removedRuleIds },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
        409: `Conflict`,
        503: `Service Unavailable`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfScheduledSocialMediaJobDto Success
   * @throws ApiError
   */
  public getScheduledJobs(): CancelablePromise<AjaxResponseOfListOfScheduledSocialMediaJobDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/social-media-automation/scheduled-jobs",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteTemplate({
    requestBody,
  }: {
    requestBody?: DeleteAutomationPostsTemplateInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/social-media-automation/templates",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfAutomationPostsTemplatesOutput Success
   * @throws ApiError
   */
  public getTemplates(): CancelablePromise<AjaxResponseOfAutomationPostsTemplatesOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/social-media-automation/templates",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public updateTemplates({
    requestBody,
  }: {
    requestBody?: UpdateAutomationPostsTemplatesInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/social-media-automation/templates",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteAutomation({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/social-media-automation/{id}",
      path: {
        id: id,
      },
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfSocialMediaAutomationDto Success
   * @throws ApiError
   */
  public getAutomationById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfSocialMediaAutomationDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/social-media-automation/{id}",
      path: {
        id: id,
      },
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
